import type { JSX } from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { Text } from '@change/ds-core-ui/Text';

import { useHero } from './hooks/useHero';

export function Hero(): JSX.Element {
	const { actions, data } = useHero();

	return (
		<div
			className="relative overflow-hidden py-20 lg:py-32"
			style={{
				background:
					'linear-gradient(84deg, var(--Red-50, #FEF2F2) 0.21%, var(--Orange-50, #FFFAED) 28.89%, var(--Yellow-50, #FFFFEB) 99.64%)',
			}}
		>
			<svg
				className="pointer-events-none absolute top-1/2 left-1/2 h-full min-h-full w-full min-w-full -translate-x-1/2 -translate-y-1/2"
				viewBox="0 0 100 100"
				preserveAspectRatio="xMidYMid meet"
				aria-hidden
			>
				<circle
					cx="50"
					cy="50"
					r="65"
					fill="none"
					stroke="#FFE600"
					strokeWidth="1"
					style={{ vectorEffect: 'non-scaling-stroke' }}
				/>
				<circle
					cx="50"
					cy="50"
					r="90"
					fill="none"
					stroke="#FFDB00"
					strokeWidth="2"
					style={{ vectorEffect: 'non-scaling-stroke' }}
				/>
				<circle
					cx="50"
					cy="50"
					r="115"
					fill="none"
					stroke="#FFB64D"
					strokeWidth="3"
					style={{ vectorEffect: 'non-scaling-stroke' }}
				/>
			</svg>
			<div className="relative z-10 container">
				<div className="flex flex-col items-center justify-center gap-6 text-center">
					<Text
						as="h1"
						variant="display"
						className="text-typography-strong-fixed text-size-heading md:text-size-display max-w-[18rem] md:max-w-2xl"
					>
						Powerful petitions for nonprofits
						<span className="text-fill-brand-strong">.</span>
					</Text>
					<Text
						as="p"
						variant="body"
						size="large"
						className="text-typography-strong-fixed md:text-size-heading-light max-w-sm md:max-w-2xl"
					>
						Turn supporters into advocates on the largest petition platform.
					</Text>
					<div className="flex flex-col gap-4 md:flex-row">
						<Button
							as="a"
							href={data.primaryCtaUrl}
							variant="primary-strong"
							className="w-full md:w-auto"
							data-qa="nonprofit-hero-start-petition-cta"
							onClick={actions.onPrimaryCtaClick}
						>
							Start a petition
						</Button>
						<Button
							as="a"
							href={data.secondaryCtaUrl}
							variant="secondary-solid"
							className="w-full md:w-auto"
							data-qa="nonprofit-hero-talk-to-team-cta"
							onClick={actions.onSecondaryCtaClick}
						>
							Talk to our team
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
}
